import React, { useState } from 'react';

import {
  useTranslate,
  useLogout,
  useTitle,
  useNavigation
} from '@pankod/refine-core';
import { AntdLayout, Menu, Grid, Icons, useMenu } from '@pankod/refine-antd';
import { useGoogleLogout } from 'react-google-login';

import { REACT_APP_GOOGLE_CLIENT_ID } from 'configs';

import { antLayoutSider, antLayoutSiderMobile } from './styles';

const { RightOutlined, LogoutOutlined } = Icons;

export const Sider: React.FC = () => {
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const { mutate: logout } = useLogout();
  const Title = useTitle();
  const translate = useTranslate();
  const { menuItems, selectedKey } = useMenu();
  const { push } = useNavigation();
  const breakpoint = Grid.useBreakpoint();

  const { signOut } = useGoogleLogout({
    clientId: REACT_APP_GOOGLE_CLIENT_ID,
    cookiePolicy: 'single_host_origin'
  });

  const isMobile = !breakpoint.lg;

  return (
    <AntdLayout.Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(isCollapsed: boolean): void => setCollapsed(isCollapsed)}
      collapsedWidth={isMobile ? 0 : 80}
      breakpoint="lg"
      width={230}
      style={isMobile ? antLayoutSiderMobile : antLayoutSider}
    >
      {Title && <Title collapsed={collapsed} />}
      <Menu
        selectedKeys={[selectedKey]}
        mode="inline"
        onClick={({ key }) => {
          if (key === 'logout') {
            signOut();
            logout();
            return;
          }

          if (!breakpoint.lg) {
            setCollapsed(true);
          }

          push(key as string);
        }}
      >
        {menuItems.map(({ icon, label, route }) => {
          const isSelected = route === selectedKey;
          return (
            <Menu.Item
              style={{
                fontWeight: isSelected ? 'bold' : 'normal'
              }}
              key={route}
              icon={icon}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                {label}
                {!collapsed && isSelected && <RightOutlined />}
              </div>
            </Menu.Item>
          );
        })}

        <Menu.Item key="logout" icon={<LogoutOutlined />}>
          {translate('buttons.logout', 'Logout')}
        </Menu.Item>
      </Menu>
    </AntdLayout.Sider>
  );
};
